// src/constants/appConstants.ts

// APP VERSION
export const CURRENT_APP_VERSION = "0.1.8";
export const CURRENT_APP_BUILD = 8004;
export const MAX_DAYS_BEFORE_NOTIFY = 180;

export const CUSTOM_INVITATION_START_PRICE = 3000;

// APP STORE LINKS
export const APP_STORE_URLS = {
  android: "https://play.google.com/store/apps/details?id=com.greetindia9",
  ios: "https://play.google.com/store/apps/details?id=com.greetindia9",
};

// MIN / MAX INPUT RULES
export const MIN_MAX_LENGTH = {
  minString: 3,
  maxString: 255,
  minPassword: 6,
  maxPassword: 25,
  resendOtpAfter: 59,
  maxFeedbackChar: 150,
  maxSupportDescChar: 150,
};

// COMMON ALERT MESSAGES
export const ALERT_MSG = {
  networkErroMsg: "Network Error",
  responseNull: "Api response error",
  loginSuccess: "You have successfully loggedin",
  registerSuccess: "Your account created successfully",
  fieldReq: "This field is required",
  minMaxReq: "$FIELD must be between $MIN and $MAX symbols",
  nameReq: "Please enter fullname",
  emailReq: "Please enter email",
  emailValid: "Please enter valid email",
  phoneNumReq: "Please enter mobile number",
  phoneNumValid: "Please enter valid mobile number",
  passwordReq: "Please enter password",
  invalidPin: "Please enter correct pin",
  sureToExit: "Are you sure you want to exit?",
};

// GENDER OPTIONS
export const GENDER_LIST = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];

// GOOGLE CONFIG
export const GOOGLE_ADS_TYPES = {
  rewarded: { name: "rewarded", adId: "" },
  interstitial: { name: "interstitial", adId: "" },
  appOpen: { name: "appOpen", adId: "" },
  bannerAd: { name: "bannerAd", adId: "" },
};

export const GOOGLE_CONFIG = {
  webClientId: "1136033713-mtlpi7b58bthdraejmqplpq2raja5gbk.apps.googleusercontent.com",
  androidClientId: "1136033713-0fhk4qo1k6ru34fs3fur5ous5a2k0n73.apps.googleusercontent.com",
  iosClientId: "",
};

// DEFAULT EXPORT FOR EASY IMPORTING
export default {
  CURRENT_APP_VERSION,
  CURRENT_APP_BUILD,
  MAX_DAYS_BEFORE_NOTIFY,
  APP_STORE_URLS,
  MIN_MAX_LENGTH,
  ALERT_MSG,
  GENDER_LIST,
  GOOGLE_ADS_TYPES,
  GOOGLE_CONFIG,
};
